module.exports = __webpack_public_path__ + "static/img/2areaB_31.c0102c8.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/2areaB_31.png
// module id = 1152
// module chunks = 1